// @ts-check
import { LINKS } from '../../../../common/consts/links';
import { Link } from './TermsAndPolicy.style';

export const DisabledGdprConsent = () => {
  return (
    <>
      By continuing, you agree to our
      <Link href={LINKS.TERMS_LINK} target='__blank'>
        Terms of Service
      </Link>
      and
      <Link href={LINKS.PRIVACY_POLICY_LINK} target='__blank'>
        Privacy Policy
      </Link>
    </>
  );
};
